function HashParams({ $window, $location = $window.location }) {
  const params = new $window.URLSearchParams($location.hash.substring(1))
  return {
    get(key) {
      return params.get(key)
    },
    has(key) {
      return params.has(key)
    },
    set(key, value) {
      params.set(key, value)
      updateURL()
    },
    delete(key) {
      params.delete(key)
      updateURL()
    },
  }

  function updateURL() {
    const { origin, pathname, search } = $location

    let url = origin + pathname + search
    if (Array.from(params.keys()).length > 0) {
      url += `#${params.toString()}`
    }
    $window.history.replaceState(null, '', url)
  }
}

module.exports = HashParams
